export enum SearchContext {
  Inline = 'inline',
  Results = 'results',
}

export interface SearchParams {
  query: string;
  categories: string[];
  product: string | null;
  pageNo: number;
  pageSize: number;
}